export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-ta-IN.f30b20ae.xlsx";